import { init, RematchDispatch, RematchRootState } from '@rematch/core';
import selectPlugin from '@rematch/select';
import immerPlugin from '@rematch/immer';
// import persistPlugin from '@rematch/persist';
// import storage from 'redux-persist/lib/storage';
// import { encryptTransform } from 'redux-persist-transform-encrypt';
import { models, RootModel } from './models';

// const persistConfig = {
//   key: 'root',
//   storage,
//   transforms: [
//     encryptTransform({
//       secretKey: 'my-super-secret-key',
//       onError(error) {
//         // eslint-disable-next-line no-console
//         console.error(error);
//       },
//     }),
//   ],
// };

export const store = init<RootModel>({
  models,
  plugins: [selectPlugin(), immerPlugin()/* , persistPlugin(persistConfig) */],
});

export type Store = typeof store;
export type Dispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel>;
